import React = require('react');
import { showDestinations, showRegions } from '../../../../../../../../data/api/api';
import { Field } from 'redux-form';
import FieldFormControl from '../../../../../../../../components/FieldFormControl';
import { addDays } from 'date-fns';
import AlternativeDatePicker from '../../../../../../../../components/AlternativeDatePicker';
import {
  annualLimit,
  validateIsFutureDate,
  isRequired,
  isValidDate,
  singleLimit
} from '../../../../../../../../util/validators';
import { TripType } from '../../../../../../../../data/api/models';
import { useEffect } from 'react';

interface IStartDateSelectorProps {
  tripType: TripType,
  startDate: string,
  change: (field, value) => void;
  isUpsell?: boolean

  renderDefinition(name: string, useProvidedString?: boolean): any;
}

export const StartDateSelector = ({
                                    tripType,
                                    renderDefinition,
                                    startDate,
                                    change,
                                    isUpsell = false
                                  }: IStartDateSelectorProps) => {

  useEffect(() => {
    if (tripType === 'annual') {
      change('endDate', '')
    }
  }, [startDate])

  const startDatePicker = React.createRef();

  const onClickEvent = (e) => {
    e.preventDefault();
    e.stopPropagation();
  }

  const isSingle = isUpsell ? false : showDestinations(tripType);

  return (
    <div>
      <div className="date-container">
        <div className={'flex--50 pt-10 pb-10'}>
          {isSingle ? 'Departure date ' : 'Start Date '}
          {isSingle ? renderDefinition('travel_dates') :
            renderDefinition('travel_dates_annual')}
        </div>
        <div className="date-picker flex--stretch pt-10 pb-10" onClick={onClickEvent}>
          <div className="alternative-date-picker">
            <div className="field start-date-input">
              <Field
                name="startDate"
                type="masked-date"
                inputmode="numeric"
                placeholder="dd/mm/yyyy"
                component={FieldFormControl}
              />
            </div>
            <div className="icon" ref={startDatePicker}>
              <Field
                name="startDate"
                minDate={new Date()}
                maxDate={showRegions(tripType) ?
                  addDays(new Date(), 180) :
                  addDays(new Date(), 365)}
                component={AlternativeDatePicker}
                validate={showRegions(tripType) ? [
                  isRequired,
                  validateIsFutureDate,
                  isValidDate,
                  annualLimit,
                ] : [
                  isRequired,
                  validateIsFutureDate,
                  isValidDate,
                  singleLimit,
                ]}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
